// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    projects_find_projects: 'Buscando entre los proyectos',
    projects_project_file: 'Leyendo la ficha del proyecto',
    projects_project_economics: 'Leyendo los números del proyecto',
    projects_projects_summary: 'Sumando los proyectos',
    projects_post_project_cost: 'Imputando un coste al proyecto',
  },
  ca: {
    projects_find_projects: 'Cercant entre els projectes',
    projects_project_file: 'Llegint la fitxa del projecte',
    projects_project_economics: 'Llegint els números del projecte',
    projects_projects_summary: 'Sumant els projectes',
    projects_post_project_cost: 'Imputant un cost al projecte',
  },
  en: {
    projects_find_projects: 'Looking through the projects',
    projects_project_file: 'Reading the project file',
    projects_project_economics: 'Reading the numbers of the project',
    projects_projects_summary: 'Adding up the projects',
    projects_post_project_cost: 'Posting a cost to the project',
  },
  fr: {
    projects_find_projects: 'Recherche parmi les projets',
    projects_project_file: 'Lecture de la fiche du projet',
    projects_project_economics: 'Lecture des chiffres du projet',
    projects_projects_summary: 'Bilan des projets',
    projects_post_project_cost: 'Imputation d’un coût au projet',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
